import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "x_panel" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Data Collect")
], -1 /* HOISTED */);
const _hoisted_3 = { class: "x_content" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Data Collect URL", -1 /* HOISTED */);
const _hoisted_7 = { class: "d-flex bottom10" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-clipboard",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_9 = { class: "x_panel" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Live Performance"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" })
], -1 /* HOISTED */);
const _hoisted_11 = { class: "x_content" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_15 = { class: "row top10" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_17 = { class: "text-muted" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_19 = { class: "x_panel" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "System Information")
], -1 /* HOISTED */);
const _hoisted_21 = { class: "x_content" };
const _hoisted_22 = {
    key: 0,
    class: "table"
};
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("th", { style: { "width": "30%" } }, "Machine Name", -1 /* HOISTED */);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("th", null, "Operating System", -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("th", null, "Processor", -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("th", null, "Total Memory", -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("th", null, "Available Disk Space", -1 /* HOISTED */);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("th", null, "Last Updated", -1 /* HOISTED */);
const _hoisted_29 = { class: "x_panel" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "Diagnostics")
], -1 /* HOISTED */);
const _hoisted_31 = { class: "x_content" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("p", null, "\r\n                    Download a ZIP archive containing recent application logs and a summary of host information.\r\n                ", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c;
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_progress_bar = _resolveComponent("b-progress-bar");
    const _component_b_progress = _resolveComponent("b-progress");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" DataCollect URL "),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                value: _ctx.dataCollectUrl,
                                placeholder: "Not configured",
                                readonly: ""
                            }, null, 8 /* PROPS */, ["value"]),
                            _createTextVNode(),
                            _createVNode(_component_b_button, {
                                class: "m-0 ms-2",
                                type: "button",
                                variant: "primary",
                                disabled: !_ctx.dataCollectUrl,
                                onClick: _ctx.copyDataCollectUrl,
                                title: "Copy to clipboard"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_8
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"])
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createCommentVNode(" Live Performance "),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", {
                            class: _normalizeClass({ 'text-danger': _ctx.cpuOverutilised })
                        }, "\r\n                            CPU Usage: " + _toDisplayString(_ctx.formatPercent((_a = _ctx.stats) === null || _a === void 0 ? void 0 : _a.cpuUsagePercent)), 3 /* TEXT, CLASS */),
                        _createTextVNode(),
                        _createVNode(_component_b_progress, {
                            max: 100,
                            variant: _ctx.cpuOverutilised ? 'danger' : 'primary'
                        }, {
                            default: _withCtx(() => {
                                var _a, _b;
                                return [
                                    _createVNode(_component_b_progress_bar, {
                                        value: (_b = (_a = _ctx.stats) === null || _a === void 0 ? void 0 : _a.cpuUsagePercent) !== null && _b !== void 0 ? _b : 0
                                    }, null, 8 /* PROPS */, ["value"])
                                ];
                            }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["variant"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", {
                            class: _normalizeClass({ 'text-danger': _ctx.memoryOverutilised })
                        }, "\r\n                            Memory Usage: " + _toDisplayString(_ctx.formatMemoryGb((_b = _ctx.stats) === null || _b === void 0 ? void 0 : _b.memoryUsedMb)) + " / " + _toDisplayString(_ctx.formatMemoryGb((_c = _ctx.stats) === null || _c === void 0 ? void 0 : _c.memoryTotalMb)), 3 /* TEXT, CLASS */),
                        _createTextVNode(),
                        _createVNode(_component_b_progress, {
                            max: 100,
                            variant: _ctx.memoryOverutilised ? 'danger' : 'primary'
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_progress_bar, { value: _ctx.memoryUsedPercent }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["variant"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("small", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(" Last updated: " + _toDisplayString(_ctx.statsLastUpdatedDisplay), 1 /* TEXT */)
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createCommentVNode(" System Information "),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_21, [
                (_ctx.systemInfo)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_23,
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.machineName || 'Unknown'), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tr", null, [
                                _hoisted_24,
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.operatingSystem || 'Unknown'), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tr", null, [
                                _hoisted_25,
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.processor || 'Unknown'), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tr", null, [
                                _hoisted_26,
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatMemoryGb(_ctx.systemInfo.totalMemoryMb)), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tr", null, [
                                _hoisted_27,
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(_ctx.systemInfo.availableDiskSpaceGb) + " GB", 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tr", null, [
                                _hoisted_28,
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(_ctx.infoLastUpdatedDisplay), 1 /* TEXT */)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _createTextVNode(),
        _createCommentVNode(" Diagnostic Logs "),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createTextVNode(),
                _createVNode(_component_b_button, {
                    variant: "primary",
                    disabled: _ctx.downloadingLogs,
                    onClick: _ctx.downloadLogs
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("i", {
                            class: _normalizeClass(["fa", _ctx.downloadingLogs ? 'fa-spinner fa-spin' : 'fa-download'])
                        }, null, 2 /* CLASS */),
                        _createTextVNode("\r\n                     " + _toDisplayString(_ctx.downloadingLogs ? 'Preparing...' : 'Download Logs'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled", "onClick"])
            ])
        ])
    ]));
}
